import React, { useState } from "react";
import AdminDashboardNavbar from "../../../../components/ui/Admin/AdminDashboardNavbar";
import AdminTopBar from "../../../../components/ui/Admin/AdminTopBar";
import AdminCitiesForm from "../../../../forms/admin/AdminCitiesForm";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";

function AdminDashboardCitiesPage() {
  // Mobile navbar handler
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  return (
    <div className="">
      <ToastContainer />
      <Helmet>
        <title>Manage Cities | Shuttlelane Portal Admin Dashboard</title>
      </Helmet>

      {/* Navbar here */}
      <AdminDashboardNavbar
        link="cities"
        isNavbarOpen={isNavbarOpen}
        setIsNavbarOpen={setIsNavbarOpen}
      />

      {/* Main content goes here */}
      <div className="w-full min-h-screen lg:pl-[6%] bg-white text-shuttlelaneBlack">
        <div className="px-7 py-5 relative">
          {/* Top bar */}
          <AdminTopBar
            isNavbarOpen={isNavbarOpen}
            setIsNavbarOpen={setIsNavbarOpen}
          />

          {/* Main content */}
          <div className="mt-24 pt-2">
            <div className="w-full">
              <AdminCitiesForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboardCitiesPage;
